export const ANNOUNCEMENT_SECTIONS = [
  {
    title: '企业介绍',
    paragraphs: [
      '中邮保险资产管理有限公司经国家金融监督管理总局批准，由中邮人寿保险股份有限公司全资发起设立，注册资本5亿元人民币，注册地位于北京，于2023年10月27日正式成立，是国内规模领先的专业保险资产管理机构。',
      '公司的经营范围为：受托管理委托人委托的人民币、外币资金；管理运用自有人民币、外币资金；与资产管理相关的咨询业务；国家金融监督管理总局批准的其他业务；国务院其他部门批准的业务。',
      '中邮资管坚持以高质量党建引领高质量发展，坚定不移走中国特色金融发展之路，践行金融工作的政治性、人民性，积极融入国家经济发展新格局。立足当前、着眼长远、立意高远、谋划未来，秉承稳健投资、长期回报的理念，通过专业细致的投研分析、充分有效的风险管理、规范严谨的投资程序，保障投资运作稳中求进。以保险资金运用为根本，以第三方资产管理业务为依托，通过专业的金融服务，切实践行服务国计民生、服务国家战略、服务保险主业的责任和使命。坚持“经营稳健、服务全面、特色鲜明、创新发展”战略发展目标，致力于将中邮资管打造成为最值得信赖的一流保险资产管理公司，助力建设金融强国。',
    ],
  },
  {
    title: '招聘条件',
    list: [
      '（一）遵守国家法律法规、社会道德规范、行业监管等规定，无不良历史记录；为人正派，遵守职业道德，个性、心理素质符合工作要求；品德端正，身体素质良好，具有承担相应工作负荷的精力和体力；符合公司履职回避管理制度相关要求。',
      '（二）热爱中邮资管事业，认同中邮资管文化和经营理念。',
      '（三）具有国家主管部门认可的大学本科及以上学历学位，海外院校留学归国人员所获学历（学位）应当取得国家教育部的学历（学位）认证。',
      '（四）具有招聘岗位需要的专业知识、工作经历、任职经历和能力素质。',
      '（五）原则上近三年来因个人原因更换全职工作单位不超过2次。',
      '（六）面向社会人员招聘（不含邮政系统单位）。',
      '（七）特别优秀的可适当放宽要求。',
    ],
    footer: '具体招聘岗位及招聘条件见“招聘职位”信息。',
  },
  {
    title: '招聘程序',
    paragraphs: [
      '网上报名 → 资格审查与筛选 → 测试测评 → 面试 → 发送录用通知 → 体检及背景调查 → 录用入职（聘任）',
    ],
  },
  {
    title: '注意事项',
    list: [
      '（一）应聘人员须在报名平台注册账号，按要求填写报名信息，在线提交申请表进行报名。',
      '（二）应聘人员须保证简历信息真实完整，如因信息不真实等情况导致不符合招聘资格条件的，取消聘用资格。',
      '（三）每名应聘人员可报1-2个志愿岗位。',
      '（四）报名过程中如有疑问，请与猎聘工作人员联系。',
    ],
  },
];
